import service from '@/store/services/settings/regions-service';

const state = {
    list: {},
    region: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, region) => {
        state.region = region;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(region => {
                commit('SET_RESOURCE', region);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(region => {
                commit('SET_RESOURCE', region);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((region) => {
                commit('SET_RESOURCE', region);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((region) => {
                commit('SET_RESOURCE', region);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    region: state => state.region,
    dropdown: (state) => {
        return state.list.map(region => ({
            id: region.id,
        }));
    }
};

const regions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default regions;
